import { request } from '../utils/Api';

export function updateUser(fields) {
  return dispatch => (
    new Promise((resolve) => {
      dispatch({
        type: 'UPDATE_USER',
        payload: fields,
      });

      resolve();
    })
  );
}

export function updateUserRemote(fields, accessToken) {
  return dispatch => (
    new Promise((resolve, reject) => {
      request('member', 'PATCH', fields, {
        Authorization: `Bearer ${accessToken}`,
      }).then((response) => {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_USER',
            payload: response.data,
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, (err) => {
        reject(err);
      });
    })
  );
}

export function getMember(id, accessToken) {
  return dispatch => (
    new Promise((resolve, reject) => {
      request(`member/${id}`, 'GET', null, {
        Authorization: `Bearer ${accessToken}`,
      }).then((response) => {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_MEMBER_BY_ID',
            payload: response.data,
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, (err) => {
        reject(err);
      });
    })
  );
}

export function logout() {
  return dispatch => (
    new Promise((resolve) => {
      dispatch({
        type: 'LOGOUT',
      });

      resolve();
    })
  );
}

export function login(email, password, stay_logged_in) { // eslint-disable-line
  return dispatch => (
    new Promise((resolve, reject) => {
      request('auth/token', 'POST', {
        email,
        password,
        stay_logged_in,
      }).then((response) => {
        if (response.status === 200) {
          dispatch({
            type: 'LOGIN',
            payload: response.data,
          });
          const date = new Date();
          date.setTime(new Date().getTime() + (7 * 24 * 60 * 60 * 1000));
          if (response.data.access_token) {
            const expires = '; expires=' + date.toUTCString();
            document.cookie = `access_token=${response.data.access_token}; expires=Fri, ${expires}; path=/`;
            document.cookie = `member_id=${response.data.id}; expires=Fri, ${expires}; path=/`;
          }
          resolve(response.data);
        } else {
          reject();
        }
      }, (err) => {
        if (err.status === 403 && err.data.error === 'verify') {
          reject('verify');
        }
        reject(err);
      });
    })
  );
}

export function facebookLogin(accessToken) { // eslint-disable-line
  return dispatch => (
    new Promise((resolve, reject) => {
      request('auth/facebook', 'POST', {
        access_token: accessToken,
      }).then((response) => {
        if (response.status === 200) {
          dispatch({
            type: 'LOGIN',
            payload: response.data,
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, (err) => {
        reject(err);
      });
    })
  );
}

export function register(data) { // eslint-disable-line
  return dispatch => (
    new Promise((resolve, reject) => {
      request('member', 'POST', data).then((response) => {
        if (response.status === 200) {
          dispatch({
            type: 'LOGIN',
            payload: response.data,
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, (err) => {
        reject(err);
      });
    })
  );
}

export function getCurrentMember(id, accessToken) {
  return dispatch => (
    new Promise((resolve, reject) => {
      request(`member/${id}`, 'GET', null, {
        Authorization: `Bearer ${accessToken}`,
      }).then((response) => {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_MEMBER_BY_ID',
            payload: response.data,
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, (err) => {
        reject(err);
      });
    })
  );
}

export function fetchCurrentMember(id, accessToken) {
  return dispatch => (
    new Promise((resolve, reject) => {
      request(`member/${id}`, 'GET', null, {
        Authorization: `Bearer ${accessToken}`,
      }).then((response) => {
        if (response.status === 200) {
          dispatch({
            type: 'UPDATE_USER',
            payload: response.data,
          });

          resolve(response.data);
        } else {
          reject();
        }
      }, (err) => {
        reject(err);
      });
    })
  );
}

export function sendNotificationReadReceipt(notificationID, type, accessToken) { // eslint-disable-line
  return dispatch => (
    new Promise((resolve, reject) => {
      dispatch({
        type: 'READ_NOTIFICATION_BY_ID',
        payload: notificationID,
      });
      request(`notifications/${notificationID}/read?type=${type}`, 'GET', null, {
        Authorization: `Bearer ${accessToken}`,
      }).then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject();
        }
      }, (err) => {
        reject(err);
      });
    })
  );
}

/* eslint-disable */
export function sendMemberVerificationRequest(id, verificationToken) {
  return dispatch => (
    new Promise((resolve, reject) => {
      request(`verify/user?Member=${id}&VerificationToken=${verificationToken}`, 'GET', null).then((response) => {
        if (response.status === 200) {
          resolve(response);
        } else {
          reject(response);
        }

      }, (err) => {
        // TODO this?
        resolve(err);
      });
    })
  );
}

export function sendContactRequest(data) {
  return dispatch => (
    new Promise((resolve, reject) => {
      request(`contact/request`, 'POST', data).then((response) => {
        if (response.status === 200) {
          resolve(response);
        } else {
          reject(response);
        }

      }, (err) => {
        // TODO this?
        resolve(err);
      });
    })
  );
}

/* eslint-disable */
export function sendForgotPasswordRequest(data) {
  return dispatch => (
    new Promise((resolve, reject) => {
      request(`forgot`, 'POST', data).then((response) => {
        resolve(response);
        if (response.status === 200) {
          resolve(response);
        } else {
          reject(response);
        }

      }, (err) => {
        // TODO this?
        resolve(err);
      });
    })
  );
}

export function sendResetPasswordRequest(data) {
  return dispatch => (
    new Promise((resolve, reject) => {
      request(`forgot/reset`, 'POST', data).then(
        (response) => {
          if (response.status === 200) {
            resolve(response);
          } else {
            resolve(response);
          }
        }, (err) => {
          // TODO this?
          resolve(err);
        });
    })
  );
}

export function resendVerification(email) {
  return dispatch => (
    new Promise((resolve, reject) => {
      request('member/verification', 'POST', {
        email,
      }).then((response) => {
        resolve(response);
      }, (err) => {
        reject(err);
      });
    })
  );
}

export function sendReviewRequest(data, accessToken) {
  return dispatch => (
    new Promise((resolve, reject) => {
      request(`member/${data.id}/review`, 'POST', data, {
        Authorization: `Bearer ${accessToken}`,
      }).then((response) => {
        if (response.status === 200) {
          resolve(response);
        } else {
          reject(response);
        }

      }, (err) => {
        // TODO this?
        resolve(err);
      });
    })
  );
}

export function reportMember(data, accessToken) {
  return dispatch => (
    new Promise((resolve, reject) => {
      request(`member/${data.id}/report`, 'POST', data, {
        Authorization: `Bearer ${accessToken}`,
      }).then((response) => {
        if (response.status === 200) {
          resolve(response);
        } else {
          reject(response);
        }

      }, (err) => {
        // TODO this?
        resolve(err);
      });
    })
  );
}



// WEBPACK FOOTER //
// ./src/actions/user.js